import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Portal from "../common/components/Portal";
import { triggerFcaNoticePrompt, setPendingAction, setPendingCancelAction } from "../common/actions";
import NoticeModal from "./NoticeModal";

const FcaNoticePrompt = () => {
    const dispatch = useDispatch();
    const { showFcaNoticePrompt, pendingAction, pendingCancelAction } = useSelector(state => state.commonReducer);

    const handleAccept = () => {
        dispatch(triggerFcaNoticePrompt(false));
        setTimeout(() => {
            if (pendingAction) {
                pendingAction();
                dispatch(setPendingAction(null));
                dispatch(setPendingCancelAction(null));
            }
        }, 300);
    };

    const handleCancel = () => {
        if (pendingCancelAction) {
            pendingCancelAction();
        }
        dispatch(setPendingAction(null));
        dispatch(setPendingCancelAction(null));
        dispatch(triggerFcaNoticePrompt(false));
    };

    if (!showFcaNoticePrompt) return null;

    return <Portal body={<NoticeModal visible={true} onAccept={handleAccept} onCancel={handleCancel} />} onCancel={handleCancel} />;
};

export default FcaNoticePrompt;
